import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { IconProps } from "./types";

export function OpenNewTabIcon({ size, ...props }: IconProps) {
    return <OpenInNewRoundedIcon fontSize={size} {...props} />;
}
